__turbopack_context__.v({
  "wrapper": "modal-header-module-scss-module__HzGgEq__wrapper",
});
